/** 商品画像URLを表示サイズに合わせる（楽天: _ex、Yahoo: /i/{g,l,m}/） */
export function resizeProductImage(url: string, size = 600): string {
  // Yahoo Shopping: 検索候補は小さい g、それ以外は余白の少ない m を使う
  if (/yimg\.jp\/i\/[glm]\//.test(url)) {
    const variant = size <= 128 ? 'g' : 'm';
    return url.replace(/\/i\/[glm]\//, `/i/${variant}/`);
  }
  // 楽天: 既存の _ex パラメータを置換
  if (/[?&]_ex=\d+x\d+/.test(url)) {
    return url.replace(/([?&])_ex=\d+x\d+/, `$1_ex=${size}x${size}`);
  }
  // 楽天 thumbnail ドメインで _ex がない場合（Books API等）は追記
  if (url.includes('thumbnail.image.rakuten.co.jp')) {
    const sep = url.includes('?') ? '&' : '?';
    return `${url}${sep}_ex=${size}x${size}`;
  }
  return url;
}

/** 作品行の楽天画像だけを最大256×256へ縮小する。ほかの配信元は変更しない。 */
export function resizeGameRowImage(url: string): string {
  // URLが補正する空白・バックスラッシュや、認証情報・ポート付きのURLは対象外。
  if (!/^https?:\/\/thumbnail\.image\.rakuten\.co\.jp(?:[/?#]|$)/i.test(url) || /[\s\\]/.test(url)) {
    return url;
  }
  try {
    if (new URL(url).hostname !== 'thumbnail.image.rakuten.co.jp') return url;
  } catch {
    return url;
  }

  const hashIndex = url.indexOf('#');
  const source = hashIndex === -1 ? url : url.slice(0, hashIndex);
  const fragment = hashIndex === -1 ? '' : url.slice(hashIndex);
  const queryIndex = source.indexOf('?');
  const path = queryIndex === -1 ? source : source.slice(0, queryIndex);
  const query = queryIndex === -1 ? '' : source.slice(queryIndex + 1);
  // 再シリアライズせず、_ex以外の順序・エンコードを保つ。重複した_exは1つへ統一。
  const params = query ? query.split('&').filter((param) => !new URLSearchParams(`?${param}`).has('_ex')) : [];
  params.push('_ex=256x256');
  return `${path}?${params.join('&')}${fragment}`;
}

export function isNoImage(url: string): boolean {
  const s = String(url ?? '');
  return s.includes('/now_printing.') || s.includes('/noimage');
}
